import React from 'react';

/**
 * ProgressBar Component
 * Displays a progress bar with percentage completion and current step information
 */
const ProgressBar = ({ 
  progress = 0, 
  currentStep = '', 
  showPercentage = true,
  showStep = true,
  size = 'md',
  color = 'blue',
  animated = true,
  className=''
}) => {
  const sizeClasses = {
    sm: 'h-1',
    md: 'h-2',
    lg: 'h-3'
  };

  const colorClasses = {
    blue: 'bg-blue-600 dark:bg-blue-500',
    teal: 'bg-teal-600 dark:bg-teal-500',
    green: 'bg-green-600 dark:bg-green-500',
    yellow: 'bg-yellow-600 dark:bg-yellow-500',
    red: 'bg-red-600 dark:bg-red-500'
  };

  // Ensure progress is between 0 and 100
  const normalizedProgress = Math.min(Math.max(progress, 0), 100);

  return (
    <div className={`w-full ${className}`}>
      {/* Progress Bar */}
      <div className="relative">
        <div className={`bg-gray-200 dark:bg-gray-700 rounded-full ${sizeClasses[size]} overflow-hidden`}>
          <div 
            className={`${colorClasses[color]} ${sizeClasses[size]} rounded-full transition-all duration-300 ease-out ${animated ? 'animate-pulse' : ''}`}
            style={{ width: `${normalizedProgress}%` }}
            role="progressbar"
            aria-valuenow={normalizedProgress}
            aria-valuemin="0"
            aria-valuemax="100"
            aria-label={`Progress: ${normalizedProgress}%${currentStep ? ` - ${currentStep}` : ''}`}
          />
        </div>
      </div>

      {/* Progress Information */}
      <div className="flex justify-between items-center mt-2">
        {showStep && (
          <p className="text-sm text-gray-600 dark:text-gray-400 flex-1 dark:text-gray-300 dark:text-gray-600">
            {currentStep || 'Loading...'}
          </p>
        )}
        {showPercentage && (
          <p className="text-sm text-gray-500 dark:text-gray-500 ml-2">
            {normalizedProgress}%
          </p>
        )}
      </div>
    </div>
  );
};

export default ProgressBar;
